var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0057 13.805H14.3734L14.1492 13.5889C14.9337 12.6764 15.4059 11.4917 15.4059 10.203C15.4059 7.32933 13.0766 5 10.203 5C7.32933 5 5 7.32933 5 10.203C5 13.0766 7.32933 15.4059 10.203 15.4059C11.4917 15.4059 12.6764 14.9337 13.5889 14.1492L13.805 14.3734V15.0057L17.8073 19L19 17.8073L15.0057 13.805ZM10.203 13.805C8.20983 13.805 6.60091 12.1961 6.60091 10.203C6.60091 8.20983 8.20983 6.60091 10.203 6.60091C12.1961 6.60091 13.805 8.20983 13.805 10.203C13.805 12.1961 12.1961 13.805 10.203 13.805Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9548e7936cb5ec14491fd0c6e48e1283.svg";
export { ForwardRef as ReactComponent };